import mitoLogError from './mitoSDK';
import utils from './utils'

function isJSON(str) {
    if (typeof str == 'string') {
        try {
            var obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }

        } catch (e) {
            // 这个上报没太大意义
            // mitoLogError({
            //     tag: 'utils|isJSON|JSONParseError',
            //     message: `str: ${str}`,
            //     error: e
            // })
            return false;
        }
    }
    console.log('It is not a string!')
}

function refresh(params) {
    let userId = window.localStorage.getItem('userId')
    if ('userId' in params && userId) {
        if (userId !== params.userId) {
            window.localStorage.clear();
            window.sessionStorage.clear();
        }
    }
}

export function setUrlParamsStorage() {
    let params = utils.getUrlParams();
    refresh(params)
    window.sessionStorage.setItem('app_params', JSON.stringify(params));
    window.localStorage.setItem('app_params', JSON.stringify(params));
    if (Boolean(params)) {
        try {
            let info = ''
            if (typeof params === 'string') {
                info = isJSON(params) ? JSON.parse(params) : JSON.parse(decodeURIComponent(params))
            } else {
                info = params
            }
            if (typeof info !== "object") {
                return
            }
            Object.keys(info).forEach(key => {
                let re_params = decodeURIComponent(info[key])
                window.sessionStorage.setItem(key, re_params);
                window.localStorage.setItem(key, re_params);
                if (isJSON(re_params)) {
                    re_params = JSON.parse(re_params)
                    if (typeof re_params === "object") {
                        Object.keys(re_params).forEach(re_key => {
                            window.sessionStorage.setItem(re_key, re_params[re_key]);
                            window.localStorage.setItem(re_key, re_params[re_key]);
                        })
                    }
                }
            })
            console.log('进来了')
        } catch (e) {
            mitoLogError({
                tag: 'utils|setUrlParamsStorage|JSONParseError',
                message: `params: ${JSON.stringify(params)}`,
                error: e
            })
            Log.log('error', { e })
        }
    }
}
setUrlParamsStorage()
